var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3536 24.1307C15.5936 24.8207 14.4236 24.8207 13.6636 24.1207L13.5536 24.0207C8.30357 19.2707 4.87357 16.1607 5.00357 12.2807C5.06357 10.5807 5.93357 8.95065 7.34357 7.99065C9.98357 6.19065 13.2436 7.03065 15.0036 9.09065C16.7636 7.03065 20.0236 6.18065 22.6636 7.99065C24.0736 8.95065 24.9436 10.5807 25.0036 12.2807C25.1436 16.1607 21.7036 19.2707 16.4536 24.0407L16.3536 24.1307Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyFavorites);
export default __webpack_public_path__ + "static/media/MyFavorites.ca5fee9a8fa4b79111b9ee40bed3f3d5.svg";
export { ForwardRef as ReactComponent };